import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useHistory, useLocation } from 'react-router-dom';
import { AppBar, Grid, IconButton, Toolbar, makeStyles, Avatar, Collapse, ClickAwayListener, Badge } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Sidebar from '../utils/sidebar/Sidebar';
import { splitPinnedMenuItems } from '../utils/sidebar/pinnedMenuItems';
import styled from 'styled-components';
import authService from '../services/auth-service';
import logo from '../assests/SM-Logo1.png';
import elements from '../assests/Elements-Logo.svg?url';
import BrandingColors from '../styles/color';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateFormStatusSelector } from '../redux/common/formValueChange/selectors';
import { updateDrawer, updateSideBarItems } from '../redux/common/formValueChange/action';
/// import { useMsal } from "@azure/msal-react";
import { IDSAuthService } from '../services/IdsServices/AuthService'
import useWindowSize from '../helper/windowResize';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import { getApi } from '../services/apiBase';
import { configuration_get, reportMenu, setting_pwd, side_BarMenu } from '../services/apiURL';
import { getSelectedProfiles } from '../redux/common/search-data/action';
import { getConfiguration } from '../redux/common/login/action';
import { typeOf } from 'react-is';
import config from '../services/config';
import Clarity from '@microsoft/clarity';
import IdleTimeOutHandler from '../utils/common/IdleTimeOutHandler';
import AristotleAssistant from '../components/AristotleAssistant/AristotleAssistant';
import { userPasswordConfiguartion } from '../redux/common/roleAccess/action';
import { postApiWithParams } from '../services/apiBase';
import { logout_url } from '../services/apiURL';
import { setDefaultRecordsPerPage } from '../redux/common/tableTracker/action';
import { fetchNotifications, markNotificationRead } from '../redux/notifications/action';
import { notificationsSelector } from '../redux/notifications/selectors';
import { getNotificationType } from '../utils/notifications/notificationTypes';
import { nextPollDelay } from '../utils/notifications/pollSchedule';
import EnvironmentBadge from '../components/EnvironmentBadge/EnvironmentBadge';
import { useFeatureFlag, useFeatureFlagContext } from '../hooks/useFeatureFlag';
import { FEATURE_FLAGS } from '../config/featureFlags';
import DataDictionaryPanel from '../pages/SystemManager/DataDictionary/DataDictionaryPanel';
import { dataDictionaryAccessSelector, ACCESS_READ } from '../redux/common/roleAccess/selectors';
import MainContent from './MainContent';
import { appBarContentStyle, headerIconButtonStyle } from './shellFocusStyles';
import { getStaffDocumentTitle } from '../route/documentTitle';

// Round 2 memory-leak fix uses requestIdleCallback to defer Clarity re-init until after GC.
// Polyfill: not all targets expose it; fall back to setTimeout(50). Returning a tagged
// handle lets the caller cancel correctly even when the underlying scheduler differs.
// The 1000 ms timeout caps the "blind window" where Clarity is not yet tracking.
const IDLE_REINIT_TIMEOUT_MS = 1000;
const FALLBACK_REINIT_DELAY_MS = 50;
const scheduleIdleReinit = (cb) => {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        return { type: 'idle', id: window.requestIdleCallback(cb, { timeout: IDLE_REINIT_TIMEOUT_MS }) };
    }
    return { type: 'timeout', id: setTimeout(cb, FALLBACK_REINIT_DELAY_MS) };
};
const cancelIdleReinit = (handle) => {
    if (!handle) return;
    if (handle.type === 'idle' && typeof window !== 'undefined' && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(handle.id);
        return;
    }
    clearTimeout(handle.id);
};

const drawerWidth = 275;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .MuiToolbar-root.header': {
            paddingLeft: 0
        }
    },
    appbarContent: appBarContentStyle,
    content: {
        padding: theme.spacing(3),
        paddingTop: theme.spacing(1),
        marginTop: theme.spacing(8),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        backgroundColor: BrandingColors.backgroundGrey,
        minHeight: 'calc(100vh - 100px)'
    },
    [theme.breakpoints.up('lg')]: {
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: + drawerWidth,
            backgroundColor: BrandingColors.backgroundGrey,
            minHeight: 'calc(100vh - 100px)',
            '@media (min-width: 1920px)': {
                marginLeft: + 325
            }
        }
    },
    [theme.breakpoints.down('sm')]: {
        contentShift: {
            pointerEvents: 'none'
        }
    },
    menuIcon: {
        '& .MuiSvgIcon-root': {
            fontSize: '1.65em'
        }
    },
    headerIconButton: headerIconButtonStyle,
    // 282116: account icon replaces the old caret. Sized here rather than inline so the
    // header glyphs stay theme-overridable and match the bell next to them.
    accountIcon: {
        fontSize: 24
    }
}));

const UserItem = styled.ul`{
    display: flex;
    width: 100%;
    justify-content: flex-end;
    >li{
        list-style-type: none;
        padding-left: 24px;
    }
    li:last-child{
        padding-left: 0px;
        position:relative;
        .submenu{
            position: absolute;
            /* 282116: the menu now hosts the user's name + ID, whose width is unknown.
               Intrinsic width anchored to the right edge grows with a long name instead of
               clipping it, and drops the magic -169px offset the fixed 200px needed. */
            min-width: 200px;
            width: max-content;
            white-space: nowrap;
            right: 0;
            left: auto;
            background: ${BrandingColors.white};
            top: 56px;
            .submenu-list{
                color: ${BrandingColors.darkGreyFont};
                padding: 0px;
                li{
                    display: flex;
                    line-height: 2.2em;
                    align-items: center;
                    padding: 5px;
                    &:hover{
                        background-color : ${BrandingColors.lightOrangeCustom};
                        color: ${BrandingColors.darkBlack};
                    }
                }
                /* 282116: the name/ID row is a label, not an action. Nested here so it
                   outranks both .submenu ul li{cursor:pointer} and the :hover highlight
                   above, which would otherwise make it look clickable. */
                li.userName{
                    cursor: default;
                    &:hover{
                        background-color: transparent;
                        color: inherit;
                    }
                }
            }
            ul{
                list-style: none;
                padding: 10px;
                li{
                    cursor: pointer;
                    span.icon-btn {
                        padding-right: 5px;
                    }
                }
               
            }
        }
    }
    /* 282116: notification bell + its placeholder dropdown. position:relative anchors the panel;
       the bell is NOT li:last-child, so it needs its own positioning context (the account menu's
       .submenu block is scoped to li:last-child and does not reach here). */
    li.notifyIcon{
        display: flex;
        align-items: center;
        position: relative;
        color: ${BrandingColors.darkGreyFont};
        .bellGlyph{
            font-size: 24px;
        }
        /* Notification list, right-anchored under the bell, grows with content. Rows are now
           data-driven and clickable (mark-read + navigate to the process's Results page). */
        .notify-panel{
            position: absolute;
            top: 56px;
            right: 0;
            left: auto;
            min-width: 240px;
            width: max-content;
            white-space: nowrap;
            background: ${BrandingColors.white};
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
            z-index: 1;
            .notify-list{
                list-style: none;
                margin: 0;
                padding: 0;
                li{
                    display: flex;
                    align-items: center;
                    line-height: 2.2em;
                    padding: 5px 12px;
                    cursor: pointer;
                    span.icon-btn{
                        padding-right: 8px;
                    }
                    &:hover{
                        background-color: ${BrandingColors.lightOrangeCustom};
                        color: ${BrandingColors.darkBlack};
                    }
                }
                /* Unread rows carry the sidebar sub-item expand tint; read rows keep the panel's
                   plain white (the Account Menu treatment), so read is simply the absence of it. */
                li.is-unread{
                    background-color: ${BrandingColors.lightGreySidebar};
                }
                /* The empty-state row is a label, not an action — no pointer, no hover highlight. */
                li.is-empty{
                    cursor: default;
                    &:hover{
                        background-color: transparent;
                        color: inherit;
                    }
                }
            }
        }
    }
}`;

const LogoWrapper = styled.div`{
    display: flex;
    align-items: center;
    padding-left: 18px;
    img{
        max-width: 100%;
        cursor: pointer;
    }
    p{
        color: ${BrandingColors.darkBlack};
        font-size: 3em;
        line-height: .8em;
        display:flex;
        span{
            font-family: 'Lato-bold';
            padding-left: 5px;
        }
        em{
            font-family: 'Lato-light';
        }
    }
}`;

const { clarityProjectId } = config.common;

export const User = styled.span`
color: ${BrandingColors.darkGreyFont};
font-size: 0.875rem;
font-weight: 500;
`
export const MainProtectedLayout = ({ children }) => {
    const [authServiceIDS] = React.useState(() => new IDSAuthService())
    /// const { instance, accounts } = useMsal();
    /// const [isLoggedInWithAzure, setLoggedInWithAzure] = useState(false);

    const classes = useStyles();
    let history = useHistory();
    const [open, setOpen] = useState(true);
    const [menuOpen, setMenuOpen] = useState(false);
    const [dataDictionaryOpen, setDataDictionaryOpen] = useState(false);
    // 282116: open/close state for the placeholder notification menu on the bell. Static list for
    // now; Feature 282120 replaces it with the real badge + data-driven notifications.
    const [notifyOpen, setNotifyOpen] = useState(false);
    const [profileName, setProfileName] = useState("")
    const [profileId, setProfileId] = useState("")
    const { sideBar, sideBarItems } = useSelector(updateFormStatusSelector, shallowEqual);
    const notifications = useSelector(notificationsSelector, shallowEqual);
    const dispatch = useDispatch();
    const { refetch: refetchFeatureFlags, isLoading: featureFlagsLoading } = useFeatureFlagContext();
    const { t } = useTranslation();
    const location = useLocation();
    const prevPathRef = useRef(location.pathname);

    useEffect(() => {
        document.title = getStaffDocumentTitle(location.pathname, t);
        return () => {
            document.title = 'Elements';
        };
    }, [location.pathname, t]);

    // Mount-cached flag value: avoids inconsistent UX if the flag flips mid-session.
    // The user keeps the same Clarity-restart behavior until logout/login. We must wait
    // for FeatureFlagContext to finish loading; reading the flag while isLoading is true
    // returns the (false) default and would freeze Wave 1 in the OFF path forever.
    const liveMemoryHygieneFlag = useFeatureFlag(FEATURE_FLAGS.FRONTEND_MEMORY_HYGIENE_ROUND2);
    const dataDictionaryFlagEnabled = useFeatureFlag(FEATURE_FLAGS.DATA_DICTIONARY);
    // The header icon opens the dictionary, so it needs the flag AND at least read access --
    // otherwise a user without the permission gets an icon that opens a panel the API refuses.
    const dataDictionaryAccess = useSelector(dataDictionaryAccessSelector);
    const dataDictionaryEnabled = dataDictionaryFlagEnabled && dataDictionaryAccess >= ACCESS_READ;
    const memoryHygieneRef = useRef(null);
    if (memoryHygieneRef.current === null && !featureFlagsLoading) {
        memoryHygieneRef.current = liveMemoryHygieneFlag;
    }
    const memoryHygieneEnabled = memoryHygieneRef.current ?? false;
    const handleToggleDrawer = () => {
        dispatch(updateDrawer(!sideBar));
    };
    const onLogout = () => {

        const payload = {
            "username": localStorage.getItem("user")
        }
        //Reset the semaphores here
        postApiWithParams(`${logout_url}`, payload).then(() => {
            //Reset the prospect data starts here
            dispatch(getSelectedProfiles({}))
            history.push({
                state: { selectedRow: {} }
            })
            
            //Reset the prospect data ends here
            authServiceIDS.getUser().then(user => {
                if (user) {
                    authService.logout(() => authServiceIDS.logout())
                    window.location.reload()
                } else {
                    authService.logout(() => history.push("/signout"));
                    window.location.reload()
                }
            })
        })
        /// if (isLoggedInWithAzure) {
        ///     instance.logoutPopup({
        ///         postLogoutRedirectUri: "/",
        ///         mainWindowRedirectUri: "/"
        ///     }).then(() => {
        ///         authService.logout(() => history.push("/signout"));
        ///     });
        /// } else {
        // authService.logout(() => history.push("/signout"));
        /// }
    }

    useEffect(() => {
        setOpen(sideBar)
    }, [sideBar])

    // Poll the notification bell. Delivery is near-real-time (no push channel exists), so the badge
    // updates on the next tick after a job completes. Self-rescheduling rather than a fixed interval
    // because the gap between polls is not constant: it stretches after consecutive failures, and
    // polling stops outright while the tab is hidden. A hidden tab is left holding no timer at all —
    // a backgrounded tab polling at full rate costs the backend a request per user per minute for a
    // badge nobody is looking at. Becoming visible again fetches immediately, so the badge (and the
    // read state a mark-read is reconciled against) is never left stale behind a long backoff.
    useEffect(() => {
        let timerId = null;
        let stopped = false;
        let inFlight = false;
        let consecutiveFailures = 0;

        const clearPending = () => {
            if (timerId !== null) {
                clearTimeout(timerId);
                timerId = null;
            }
        };

        const scheduleNext = () => {
            clearPending();
            if (stopped || document.hidden) return;
            timerId = setTimeout(runPoll, nextPollDelay(consecutiveFailures));
        };

        // Only ever one poll in flight. Hiding the tab cancels the pending timer but cannot cancel an
        // outstanding request, so without this guard a hide-then-show inside one request's lifetime
        // would start a second poll: the two responses could then settle out of order and the older
        // one would overwrite the store with stale notifications and skew the failure count. Skipping
        // the duplicate is safe rather than lossy — the request already in flight was just issued, so
        // its result is the fresh data the returning tab wants anyway. Ceiling: no axios timeout is
        // configured, so a stalled request holds the loop until the browser errors it (the thunk then
        // resolves false and the `finally` releases the flag); set an explicit timeout if that bites.
        async function runPoll() {
            if (stopped || inFlight || document.hidden) return;
            inFlight = true;
            let succeeded;
            try {
                succeeded = await dispatch(fetchNotifications());
            } finally {
                inFlight = false;
            }
            if (stopped) return;
            consecutiveFailures = succeeded ? 0 : consecutiveFailures + 1;
            scheduleNext();
        }

        const handleVisibilityChange = () => {
            if (document.hidden) {
                clearPending();
            } else {
                runPoll();
            }
        };

        if (!document.hidden) {
            runPoll();
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            stopped = true;
            clearPending();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [dispatch]);

    // Clicking a notification does two things: mark it read and route to its Results page. The
    // mark-read is fired first but not awaited, so navigation is never blocked on the write (a
    // failed write self-heals on the next poll). The panel closes either way.
    const handleNotificationClick = (notification) => {
        const config = getNotificationType(notification.taskType);
        if (!notification.isRead) {
            // Pass the whole row so every collapsed run in the group is marked read, not just the newest.
            dispatch(markNotificationRead(notification));
        }
        setNotifyOpen(false);
        if (config?.route) {
            // A row may carry router state for a page that must react even when it is already open.
            history.push(config.route, config.state);
        }
    };

    useEffect(() => {
        Clarity.init(clarityProjectId);

        getApi(configuration_get).then((resp) => {
            let data = resp.data.data ? resp.data.data : {}
            dispatch(getConfiguration(data))
            dispatch(setDefaultRecordsPerPage(data.camsConfig))
        }).catch((err) => console.log(err))

        // Fetch feature flags now that user is authenticated
        refetchFeatureFlags();

        return () => {
            if (typeof window.clarity === 'function') window.clarity('stop');
        }
    }, []);

    // Restart Clarity on route changes to release detached DOM references.
    // Clarity's internal Map accumulates references to DOM elements it tracks.
    // When React unmounts a page, those DOM elements become detached but Clarity
    // still holds them, preventing GC of the entire React FiberNode subtree.
    useEffect(() => {
        if (location.pathname === prevPathRef.current) return;
        prevPathRef.current = location.pathname;

        // Stop current Clarity session to release tracked DOM references
        if (typeof window.clarity === 'function') {
            window.clarity('stop');
        }

        // Remove every clarity script tag. Anchor the selector to the Microsoft Clarity
        // host so we never strip unrelated 3rd-party scripts that happen to contain the
        // word "clarity" in their src. Round 1 only looked at id=clarity-script which
        // misses SDK builds that use a different id.
        const scriptNodes = document.querySelectorAll('script[src*="clarity.ms"]');
        scriptNodes.forEach((node) => {
            if (node.parentNode) node.parentNode.removeChild(node);
        });
        const legacyScript = document.getElementById('clarity-script');
        if (legacyScript && legacyScript.parentNode) {
            legacyScript.parentNode.removeChild(legacyScript);
        }

        // Clear the global clarity function. Some SDK builds define it with
        // configurable: false; under strict mode `delete` would throw, so prefer
        // assignment which works regardless of the descriptor.
        window.clarity = undefined;

        // Round 2: defer re-init to an idle callback so the GC has a real chance
        // to reclaim the detached subtree before the new SDK starts tracking again.
        // Round 1 used a fixed setTimeout(100), which was arbitrary.
        if (memoryHygieneEnabled) {
            const idleHandle = scheduleIdleReinit(() => Clarity.init(clarityProjectId));
            return () => cancelIdleReinit(idleHandle);
        }
        // Legacy path (flag OFF): preserve Round 1 behavior verbatim.
        const timerId = setTimeout(() => Clarity.init(clarityProjectId), 100);
        return () => clearTimeout(timerId);
    }, [location.pathname, memoryHygieneEnabled]);
    
    const [width] = useWindowSize();

    useEffect(() => {
        if (width) {
            if (width <= 1282) {
                dispatch(updateDrawer(false));
            } else {
                dispatch(updateDrawer(true));
            }
        }
    }, [width])

    useEffect(() => {
        const username = localStorage.getItem("username")
        const userId = localStorage.getItem("userId")
        /// localStorage.getItem("authMode") === 'azureClient' && setLoggedInWithAzure(true);
        if (username !== "undefined" && username) {
            setProfileName(username)
            setProfileId(userId)
        }
        // else {
        //     authServiceIDS.getUser().then(user => {
        //         console.log("user data: ", user)
        //         if (user) {
        //             const { name } = user.profile
        //             setProfileName(name)
        //         } else {
        //             authServiceIDS.renewToken().then((data) => {
        //                 if(data)
        //                 {
        //                 const { name } = data.profile
        //                         setProfileName(name)
        //                 console.log("signinSilent data : ", data)
        //                 }                        
        //             }).catch(error => {
        //                 console.log(error)
        //             })
        //         }
        //     })
        // }

        getApi(setting_pwd).then((resp) => {
            if((Object.keys(resp.data.data).length > 0)){
                dispatch(userPasswordConfiguartion(resp.data.data))
            }
        }).catch((err) => {
            console.log(err)
        })

    }, [])
    
    useEffect(() => {
        const abortController = new AbortController();
        const { signal } = abortController;        

        if (sideBarItems.length === 0) {
            getApi(`${side_BarMenu}`,{signal}).then((resp) => {
                const { sidebarItems } = resp.data.data;
                // Held back and re-appended below, so they stay at the bottom of the menu.
                const { items, pinned } = splitPinnedMenuItems(sidebarItems);
                dispatch(updateSideBarItems(items));
                getApi(`${reportMenu}`).then((res) => {
                    const { result } = res.data.data;
                    if (typeof result === 'string') {
                        dispatch(updateSideBarItems(JSON.parse(result)));
                    } else if (typeof result === 'object') {
                        dispatch(updateSideBarItems(result));
                    }
                }).catch((err) => {
                    console.log('Error in response')
                }).finally(() => {
                    // Runs on failure too, so a bad Reports response cannot drop them.
                    dispatch(updateSideBarItems(pinned));
                })
            }).catch((err) => {
                console.log(err)
            })
        }

        return () => {
            abortController.abort();
        }  
    }, [])

    const handleChangePassword = () => {
        history.push("/change-password")
    }

    return (
        <Grid container className={classes.root}>
            <AppBar className={classes.appbarContent}>
                <Toolbar className="header">
                    <LogoWrapper>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleToggleDrawer}
                            className={`${classes.menuIcon} ${classes.headerIconButton}`}
                            edge="start"
                            sx={{ mr: 2, ...(open && { display: 'none' }) }}
                        >
                            <MenuIcon aria-hidden="true" />
                        </IconButton>
                        {/* <img src={logo} alt="logo" /> */}
                        <Link to="/home">
                            <Tooltip title={t('menuItem.home')} arrow>
                                <img src={elements} alt={'logo'} style={{ margin: '5px 0 0 5px' }} />
                            </Tooltip>
                        </Link>
                        <EnvironmentBadge position="header" compact />
                    </LogoWrapper>
                    <UserItem>
                        {dataDictionaryEnabled && (
                            <li className="userInfo">
                                <Tooltip title={t('menuItem.dataDictionary')} arrow>
                                    <IconButton
                                        aria-label={t('menuItem.dataDictionary')}
                                        color="inherit"
                                        onClick={() => setDataDictionaryOpen(true)}
                                        className={classes.headerIconButton}
                                    >
                                        <span className="material-icons-outlined" aria-hidden="true">menu_book</span>
                                    </IconButton>
                                </Tooltip>
                            </li>
                        )}
                        {/* Notification bell: a red unread-count badge on the glyph, and a data-driven
                            list from the store. Rows stay direct <li> children of ul.notify-list —
                            no nested <ul> (VPAT 48d3f0e0de). Same open/close + click-away pattern as
                            the account menu below. */}
                        <ClickAwayListener onClickAway={() => notifyOpen && setNotifyOpen(false)}>
                            <li className="notifyIcon">
                                <IconButton
                                    aria-label={t('commonLabel.notifications')}
                                    aria-haspopup="true"
                                    aria-expanded={notifyOpen}
                                    color="inherit"
                                    onClick={() => setNotifyOpen(!notifyOpen)}
                                    className={classes.headerIconButton}
                                >
                                    <Badge
                                        badgeContent={notifications.unreadCount}
                                        color="error"
                                        invisible={notifications.unreadCount === 0}
                                    >
                                        <span className="bellGlyph material-icons-outlined" aria-hidden="true">notifications_none</span>
                                    </Badge>
                                </IconButton>
                                <div className="notify-panel">
                                    <Collapse in={notifyOpen}>
                                        <ul className="notify-list">
                                            {notifications.items.length === 0 ? (
                                                <li className="is-empty">
                                                    <span>{t('commonLabel.notifNone')}</span>
                                                </li>
                                            ) : (
                                                notifications.items.map((n) => {
                                                    // Skip any TaskType not in the map rather than
                                                    // rendering a blank/broken row.
                                                    const config = getNotificationType(n.taskType);
                                                    if (!config) return null;
                                                    return (
                                                        <li
                                                            key={n.backgroundTaskId}
                                                            className={n.isRead ? 'is-read' : 'is-unread'}
                                                            onClick={() => handleNotificationClick(n)}
                                                        >
                                                            <span className="icon-btn material-icons-outlined" aria-hidden="true">{config.icon}</span>
                                                            <span>{t(config.textKey)}</span>
                                                        </li>
                                                    );
                                                })
                                            )}
                                        </ul>
                                    </Collapse>
                                </div>
                            </li>
                        </ClickAwayListener>
                        {/* 282116: close the account menu on any outside click. ClickAwayListener
                            (MUI v4, already imported) covers mouse + touch; the guard skips a
                            needless state set when the menu is already closed. */}
                        <ClickAwayListener onClickAway={() => menuOpen && setMenuOpen(false)}>
                            <li>
                                <IconButton
                                    aria-label={t('commonLabel.accountMenu')}
                                    aria-haspopup="true"
                                    aria-expanded={menuOpen}
                                    edge="end"
                                    color="inherit"
                                    onClick={() => setMenuOpen(!menuOpen)}
                                    className={classes.headerIconButton}
                                >
                                    <AccountCircleIcon className={classes.accountIcon} aria-hidden="true" />
                                </IconButton>
                                <div className='submenu'>
                                    <Collapse in={menuOpen}>
                                        <ul className='submenu-list'>
                                            {/* 282116: name + ID moved out of the app bar into the menu.
                                                Label only — no onClick, no role, and a direct <li> child
                                                (no nested <ul>) to keep the VPAT list fix from 48d3f0e0de. */}
                                            <li className="userName">
                                                <User>{profileName} ID: {profileId}</User>
                                            </li>
                                            <li onClick={onLogout}>
                                                <span className="icon-btn material-icons-outlined" aria-hidden="true">logout</span>
                                                <span>{t('commonLabel.signOut')}</span>
                                            </li>
                                            <li onClick={handleChangePassword}>
                                                <span className="icon-btn material-icons-outlined" aria-hidden="true">lock_reset</span>
                                                <span>{t('commonLabel.changePassword')}</span>
                                            </li>
                                        </ul>
                                    </Collapse>
                                </div>
                            </li>
                        </ClickAwayListener>
                    </UserItem>
                </Toolbar>
            </AppBar>
            <Grid item lg={12} className={'bg-green'}>
                <Sidebar
                    variant="persistent"
                    anchor="left"
                    open={open} />
                <MainContent
                    className={clsx(`${classes.content} appBar`, {
                        [classes.contentShift]: open
                    })}
                >
                    <IdleTimeOutHandler />
                    {children}
                    {/* Keep the fixed assistant mounted with the active page so its
                        exposed launcher/panel is contained by the page landmark. */}
                    <AristotleAssistant />
                </MainContent>
            </Grid>
            {dataDictionaryEnabled && <DataDictionaryPanel open={dataDictionaryOpen} onClose={() => setDataDictionaryOpen(false)} />}
        </Grid>
    );
}
